import { z } from "zod";
/**
 * Health convention for every service:
 * - `GET /health` (liveness): 200 while the process is up.
 * - `GET /ready` (readiness): 200 when every dependency check passes, 503 otherwise.
 */
export const HEALTH_PATHS = { live: "/health", ready: "/ready" };
export const HealthCheckResultSchema = z.object({
    name: z.string().min(1),
    status: z.enum(["ok", "failing"]),
    detail: z.string().optional(),
});
export const HealthResponseSchema = z.object({
    status: z.enum(["ok", "failing"]),
    service: z.string().min(1),
    version: z.string().min(1),
    uptimeSeconds: z.number().nonnegative(),
    checks: z.array(HealthCheckResultSchema),
});
//# sourceMappingURL=health.js.map